import { t } from "@/i18n-js/instance";
import { ExecutePreviewCard } from "./ExecutePreviewCard";

export interface AccessGroupExecutePreviewProps {
  description?: string;
  member_count?: number;
  name?: string;
}

export const AccessGroupExecutePreview = ({
  name,
  description,
  member_count,
}: AccessGroupExecutePreviewProps) => {
  const membersText =
    member_count != null
      ? t("help_widget.copilot.execute_preview.members_count", {
          count: member_count,
        })
      : undefined;

  return (
    <ExecutePreviewCard
      title={t("help_widget.copilot.execute_preview.access_group_title")}
      attributes={[
        {
          label: t("help_widget.copilot.execute_preview.name"),
          value: name,
        },
        {
          label: t("help_widget.copilot.execute_preview.description"),
          value: description,
        },
        {
          label: t("help_widget.copilot.execute_preview.number_of_members"),
          value: membersText,
        },
      ]}
    />
  );
};
